import React, { PureComponent } from 'react';
import './index.less';

import ClickOutside from 'react-onclickoutside';

import renderPopup from './render-popup';

class Popup extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			canClickOutside: true
		};

		this.changeAbilityToClickOutside = this.changeAbilityToClickOutside.bind(this);
	}

	changeAbilityToClickOutside(canClickOutside) {
		this.setState({ canClickOutside });
	}

	handleClickOutside() {
		if (this.state.canClickOutside) {
			this.props.close();
		}
	}

	render() {
		const { popup, click, close } = this.props;
		return (
			<div className='dashboard-popup-wrapper'>
				{renderPopup(popup, {
					click: (e, payload = undefined) => click(payload),
					changeAbilityToClickOutside: this.changeAbilityToClickOutside
				})}
				<button
					className='dashboard-popup-close'
					onClick={close}
				/>
			</div>
		);
	}
}

export default ClickOutside(Popup);


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/root/components/popup-window/popup/index.js